// extracted by mini-css-extract-plugin
module.exports = {"ratingLabel":"RatingLabel_ratingLabel__jlFm8","number":"RatingLabel_number__N8njk","icon":"RatingLabel_icon__0opAf"};